import { Injectable } from '@angular/core';

import { UserListModel } from '~app/models/responses/user-list.model';
import { UserModel } from '~app/models/user.model';
import { BaseCrudStore } from '~core/abstractions/base-crud.store';
import { StoreConfig } from '~core/models/store.config';

@Injectable({
    providedIn: 'root'
})
export class ResellersStore extends BaseCrudStore<UserModel, UserListModel> {
    constructor() {
        super(new StoreConfig({ baseController: 'resellers' }));
    }
}
